<template>
  <div>
    <slot :openModal="openModal"></slot>
    <b-modal size="md" :title="modalTitle" hide-footer v-model="showModal">
      <div v-if="state === 'form'">
        <div class="tw-font-medium">
          By deleting your {{ deleteType === "profile" ? "profile" : "customer account" }}
        </div>

        <ul class="tw-mt-5">
          <li>You will no longer be able to access your pocstock account</li>
          <li>All associated data will be permanently deleted</li>
          <li v-for="opt in filteredDeleteOptions" v-if="filteredDeleteOptions">
            {{ opt.message }}
            <div class="tw-text-sm text-gray-500" v-if="opt.sub_message">{{ opt.sub_message }}</div>
          </li>
        </ul>

        <form @submit="handleDeleteProfile" ref="form" class="tw-mt-5">
          <b-form-group label="Why are you deleting your profile?">
            <b-form-select v-model="reason" :options="reasons" required></b-form-select>
          </b-form-group>

          <b-form-group label="Other reason" v-if="reason === 'Other'">
            <b-form-input type="text" v-model="customReason" required></b-form-input>
          </b-form-group>

          <b-form-group label="Assign admin role to another user" v-if="requiresAdminCandidate">
            <v-select v-model="user"
                      @search="fetchUsers"
                      :options="users"
                      :filterable="false">
              <template #no-options>
                type to search user...
              </template>
              <template #option="user">
                {{ user.first_name }} {{ user.last_name }}
              </template>
              <template #selected-option="user">
                {{ user.first_name }} {{ user.last_name }}
              </template>
            </v-select>
          </b-form-group>

          <b-form-group label="Please type your password to confirm">
            <b-form-input type="password" v-model="password" required></b-form-input>
          </b-form-group>

          <div class="tw-flex tw-justify-end tw-gap-4">
            <button class="btn btn-secondary btn-rounded" type="button" @click="showModal = false">No, Thanks</button>
            <button class="btn btn-primary btn-rounded" type="submit">Yes, Delete</button>
          </div>
        </form>
      </div>

      <div v-else-if="state === 'deleteError'" class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-py-8">
        <div class="tw-text-2xl tw-font-semibold">
          Account can't be deleted!
        </div>

        <i class="far fa-times-circle fa-4x text-danger"></i>

        <div class="tw-px-16 tw-text-center">Your account cannot be deleted. Please contact support</div>

        <button class="btn btn-primary btn-rounded" @click="handleIntercom">Contact Support</button>
      </div>

      <div v-else-if="state === 'deleteSuccess'">
        <div class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-py-8">
          <div class="tw-text-2xl tw-font-semibold">
            Account deleted!
          </div>

          <i class="far fa-check-circle fa-4x text-primary"></i>

          <div class="tw-px-16 tw-text-center">
            Your account has been successfully deleted. All data will be deleted within 30 days.
          </div>

          <div class="tw-text-sm tw-text-gray-500">
            You have been signed out and will be redirected in {{ seconds }} seconds
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {UsersApi} from "../../Api/UsersApi.js";
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import vSelect from "vue-select";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default {
  components: {vSelect},
  props: ['deleteReasons', 'deleteOptions', 'isCompanyAdmin', 'deleteType'],
  //deleteType: "profile", "organization"
  mixins: [GeneralMixins],
  data() {
    return {

      showModal: false,
      state: "form",
      reason: "",
      customReason: "",
      password: "",
      users: [],
      user: null,
      seconds: 5
    }
  },

  methods: {
    fetchUsers(search, loading) {
      loading(true)
      this.searchLicensees(loading, search, this)
    },

    searchLicensees: _.debounce(async (loading, search, vm) => {
      try {
        vm.users = await OrganizationsApi.getAdminCandidates(search)
      } catch (e) {
        console.log(e);
      }
      loading(false)
    }, 150),

    handleIntercom() {
      if ('undefined' !== typeof Intercom) {
        Intercom('show')
      }
    },

    openModal() {
      this.showModal = true
    },

    redirect() {
      setTimeout(() => {
        window.location.href = "/"
      }, 5000)

      setInterval(() => {
        this.seconds--
      }, 1000)
    },

    async handleDeleteProfile(e) {
      e.preventDefault()
      if (!this.$refs.form.reportValidity()) {
        return;
      }

      if (this.requiresAdminCandidate && !this.user) {
        this.showErrorToast("Please select a user to assign admin role")
        return
      }

      try {
        await UsersApi.deleteCustomer(this.params)
        this.state = "deleteSuccess"
        this.redirect()
      } catch (e) {
        if (e.body.customer_delete_error) {
          this.state = "deleteError"
        } else {
          this.showErrorToast(this.getErrorMessages(e.body, true));
        }
      }
    }
  },

  mounted() {
    this.reason = this.reasons[0]
  },

  computed: {
    filteredDeleteOptions() {
      if (!this.deleteOptions || !this.deleteOptions.length) {
        return []
      }

      if (this.requiresAdminCandidate) {
        return this.deleteOptions.filter(opt => opt.key !== "other_users")
      } else {
        return this.deleteOptions
      }
    },

    params() {
      const reason = this.reason === "Other" ? this.customReason : this.reason

      return {
        delete_reason: reason,
        type: this.deleteType,
        admin_candidate_id: this.user ? this.user.id : null,
        password: this.password
      }
    },

    requiresAdminCandidate() {
      return this.isCompanyAdmin && this.deleteType === "profile" &&
        this.deleteOptions && this.deleteOptions.some(opt => opt.key === "other_users")
    },

    modalTitle() {
      return this.deleteType === "profile" ? "Delete Profile" : "Delete Customer Account"
    },

    reasons() {
      return [
        ...(this.deleteReasons || []),
        "Other"
      ]
    }
  }
}
</script>
